export const domain = process.env.NODE_ENV === 'development' ?
  `http://localhost:5001/${process.env.REACT_APP_FIREBASE_PROJ_ID}/us-central1/api` :
  `https://${process.env.REACT_APP_WEB_HOST_URI}/api`


// A unique query string to append to any static URL resources (e.g. /public/**) that we want to NOT cache between App versions.
export const cacheBust = typeof(process.env.REACT_APP_GIT_SHA) === 'string' ? `?v=${process.env.REACT_APP_GIT_SHA.slice(0, 10)}` : ''
